import { ServiceLocator } from '../../app/ServiceLocator';
import { TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { TelemetryService, ValidTelemetryEvent } from '../../ts/services/TelemetryService';
import { UploadWorkbookErrorEvent } from '../components/UploadWorkbookDialog';
import UploadWorkbookDialogHelper from './UploadWorkbookDialogHelper';

export interface UploadWorkbookEntryPointEvent extends ValidTelemetryEvent<UploadWorkbookEntryPointEvent> {
  type: TelemetryEvents.UploadWorkbookEntryPoint;
  origin: 'welcome-banner' | 'new-menu';
}

export interface UploadWorkbookDialogDetailEvent extends ValidTelemetryEvent<UploadWorkbookDialogDetailEvent> {
  type: TelemetryEvents.UploadWorkbookDialogDetails;
  file_selection_type: 'DragDrop' | 'SelectButton';
  file_extension: string;
  file_size_in_kb: number;
  error_event: UploadWorkbookErrorEvent;
}

export interface UploadWorkbookActionDetailEvent extends ValidTelemetryEvent<UploadWorkbookActionDetailEvent> {
  type: TelemetryEvents.UploadWorkbookActionDetails;
  upload_duration_in_ms: number;
  file_size_in_kb: number;
  success: boolean;
  error_message: string;
}


export function sendUploadWorkbookEntryPointTelemetry(origin: 'welcome-banner' | 'new-menu') {
  const telemetryService = ServiceLocator.get<TelemetryService>('TelemetryService');
  telemetryService.sendEvent<UploadWorkbookEntryPointEvent>({
    type: TelemetryEvents.UploadWorkbookEntryPoint,
    origin: origin
  });

}

export function sendUploadWorkbookDialogTelemetry(source: 'DragDrop' | 'SelectButton', file: File, errorEvent: UploadWorkbookErrorEvent) {
  const telemetryService = ServiceLocator.get<TelemetryService>('TelemetryService');
  telemetryService.sendEvent<UploadWorkbookDialogDetailEvent>({
    type: TelemetryEvents.UploadWorkbookDialogDetails,
    file_selection_type: source,
    file_extension: UploadWorkbookDialogHelper.getFileExtension(file.name),
    file_size_in_kb: file.size / 1024,
    error_event: errorEvent
  });
}

export function sendUploadWorkbookActionTelemetry(uploadDurationInMs: number, fileSize: number, isPublishSuccessful: boolean, errorMsg: string) {
  const telemetryService = ServiceLocator.get<TelemetryService>('TelemetryService');
  telemetryService.sendEvent<UploadWorkbookActionDetailEvent>({
    type: TelemetryEvents.UploadWorkbookActionDetails,
    upload_duration_in_ms: uploadDurationInMs,
    file_size_in_kb: fileSize / 1024,
    success: isPublishSuccessful,
    error_message: errorMsg
  });
}



